import { useState } from 'react';
import s from './UserSettings.module.scss';
import clsx from 'clsx';
import Button from 'components/shared/Button';
import img1 from 'images/new-icons/men-icon.png';
import img2 from 'images/new-icons/women-icon.png';
import useUpdateGender from 'sdk/hooks/user/useUpdateGender';
import useUser from 'sdk/hooks/user/useProfile';
import { useGetMyUser } from 'sdk/hooks/user/useGetMyUser';
import { useTranslation } from 'react-i18next';

const GenderSelector = () => {
  const { mutate: updateGender, isLoading } = useUpdateGender();
  const userData = useUser();
  const userId = userData?.data?.id || '';
  const { data: user, isLoading: userLoading, refetch } = useGetMyUser(userId);
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const { t } = useTranslation() as any;
  const gender = user?.gender;

  const handleGenderSelect = (gender: number) => {
    setLoadingId(gender);
    updateGender(
      { userId, gender },
      {
        onError: error => {
          console.error('Failed to update gender:', error);
        },
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  if (userLoading) {
    <div>Loading...</div>;
  }

  return (
    <div className={s.gender_selector}>
      <div className={s.gender_selector__text}>{t('select_who_you_are')}</div>
      <div className={s.gender_selector__sex}>
        <div className={s.gender_selector_option}>
          <img
            className={clsx(s.gender_selector__img, gender === 2 && s.gender_selector_active)}
            src={img1}
            alt="Men"
          />
          <div className={s.gender_selector_wrapper}>
            <Button
              disabled={gender === 1}
              darkGreen
              wide
              noHeight
              className={s.gender_selector_button}
              onClick={() => handleGenderSelect(1)}
              loading={loadingId === 1 && isLoading}
            >
              {t('for_him')}
            </Button>
          </div>
        </div>
        <div className={s.gender_selector_option}>
          <img
            className={clsx(s.gender_selector__img, gender === 1 && s.gender_selector_active)}
            src={img2}
            alt="Women"
          />
          <div className={s.gender_selector_wrapper}>
            <Button
              disabled={gender === 2}
              darkGreen
              noHeight
              className={s.gender_selector_button}
              wide
              onClick={() => handleGenderSelect(2)}
              loading={loadingId === 2 && isLoading}
            >
              {t('for_her')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderSelector;
